﻿import { debounce } from './utils';

const syncElements = document.querySelectorAll('[data-sync]');

syncElements.forEach((syncElement) => {
  let option = JSON.parse(syncElement.dataset.sync);

  syncElement.addEventListener('keyup', debounce(() => {
	option.targets.forEach((selector) => {
	  let target = document.querySelector(selector);
	  target.value = syncElement.value;
	});
  }, 300));
});